import request from '@/utils/request';


// Role
export function roleList(params) {
  return request({ url: `/roles/`, method: 'get', params })
}

export function roleCreate(data) {
  return request({ url: `/roles/add`, method: 'post', data })
}

export function roleUpdate(data) {
  return request({ url: `/roles/update`, method: 'post', data })
}

export function roleDestroy(data) {
  return request({ url: `/roles/`, method: 'post', data })
}


// User
export function userList(params) {
  return request({ url: `/users/getList`, method: 'get', params })
}

export function userCreate(data) {
  return request({ url: `/users/add`, method: 'post', data })
}

export function userUpdate(data) {
  return request({ url: `/users/add`, method: 'post', data })
}

export function userDestroy(data) {
  return request({ url: `/users/delete`, method: 'post', data })
}

export function userResetPassword(data) {
  return request({ url: `/users/reset_password`, method: 'post', data })
}
